<template>
  <!-- 推荐视频 -->
  <div class="detrecomvideo">
    <div class="zjbthea between">
      <div>推荐视频解答</div>
      <div class="mo" @click="tovideo">更多></div>
    </div>
    <div class="tjlist">
      <div class="tjitem flex_start" v-for="(item,index) in list" :key="index" @click="tojump(item)">
        <div class="covvie">
          <img src="../../../assets/question/spsf_sample.png" class="img1" />
          <div class="videoplay center">
            <svg-icon icon-class="linear-play" />
          </div>
        </div>
        <div class="rigtext">
          <div class="tjviebt ellipsis">{{item.title}}</div>
          <div class="tjlawname">{{item.true_name}}律师</div>
          <div class="tjtime">
          {{item.updated_at}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['list'],
  methods:{
     tojump(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
    tovideo(){
      this.$router.push({
        path: "/laws/videoclaim",
      });
    }
  }
};
</script>

<style lang="scss" scope>
.detrecomvideo {
  width: 100%;
  padding: 10px 10px 20px;
  .zjbthea {
    padding: 14px 20px 14px 10px;
    border-bottom: 1px solid #eee;
    font-size: 18px;
    color: #333333;
    .mo {
      font-size: 14px;
      color: #999999;
      cursor: pointer;
    }
  }
  .tjlist {
    padding: 0 10px;
    .tjitem {
      margin-top: 20px;
      align-items: flex-start;
      cursor: pointer;
      .covvie {
        position: relative;
        margin-right: 10px;
        .img1 {
          width: 124px;
          height: 70px;
        }
        .videoplay {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          font-size: 30px;
          color: #999;
        }
      }
      .rigtext {
        font-size: 12px;
        width: 140px;
        color: #999999;
        .tjviebt {
          font-size: 14px;
          color: #333333;
        }
        .tjlawname {
          margin: 8px 0;
        }
      }

      &:hover {
        .rigtext .tjviebt {
          color: #0465ea;
        }
      }
    }
  }
}
</style>